module.exports = __webpack_public_path__ + "img/chest2.639d98e5.png";